"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxDataObjectBuilder = void 0;
var realmforge_common_1 = require("realmforge-common");
var realms_three_1 = __importDefault(require("realms-three"));
var utils_1 = require("../utils");
var AbstractDataObjectBuilder_1 = require("./AbstractDataObjectBuilder");
var BoxDataObjectBuilder = /** @class */ (function (_super) {
    __extends(BoxDataObjectBuilder, _super);
    function BoxDataObjectBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*
     * Creates a dataobject
     */
    BoxDataObjectBuilder.prototype.createDataObject = function (params) {
        var _a;
        return __assign(__assign({}, this.utils.createBaseDataObject(params)), { type: realmforge_common_1.DataObjectType.Box, material: (_a = params.material) !== null && _a !== void 0 ? _a : null, geometry: params.geometry, shapeProperties: params.shapeProperties });
    };
    BoxDataObjectBuilder.prototype.getDefaultCreateParams = function (_a) {
        var blueprintId = _a.blueprintId;
        return {
            type: realmforge_common_1.DataObjectType.Box,
            geometry: {
                type: realmforge_common_1.DataObjectGeometryType.Box,
                width: 1,
                height: 1,
                depth: 1,
            },
            shapeProperties: {
                physicsType: realmforge_common_1.PhysicsType.Body,
            },
            blueprintId: blueprintId,
        };
    };
    /*
     * Builds the object
     */
    BoxDataObjectBuilder.prototype.buildThreeObject = function (dataObject, _, methods) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, width, height, depth;
            return __generator(this, function (_b) {
                _a = dataObject.geometry, width = _a.width, height = _a.height, depth = _a.depth;
                return [2 /*return*/, this.updateThreeObject(dataObject, new realms_three_1.default.Mesh(new realms_three_1.default.BoxGeometry(width, height, depth), new realms_three_1.default.MeshPhongMaterial({
                        color: (0, utils_1.hexStringToNumber)(realmforge_common_1.DEFAULT_SHAPE_COLOR),
                    })), methods)];
            });
        });
    };
    /*
     * Updates dataobject
     */
    BoxDataObjectBuilder.prototype.updateDataObject = function (oldDataObject, params) {
        var newDataObject = __assign(__assign({}, oldDataObject), this.utils.updateBaseDataObject(oldDataObject, params));
        if (params.material !== undefined) {
            // Update new
            newDataObject.material = params.material;
        }
        if (params.geometry !== undefined) {
            // Update new
            newDataObject.geometry = params.geometry;
        }
        if (params.shapeProperties !== undefined) {
            // Update new
            newDataObject.shapeProperties = params.shapeProperties;
        }
        return newDataObject;
    };
    /*
     * Updates the three object
     */
    BoxDataObjectBuilder.prototype.updateThreeObject = function (params, threeObject, methods) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        threeObject = this.utils.setThreeProperties(params, threeObject);
                        return [4 /*yield*/, this.utils.setThreeMaterial(params, threeObject, methods)];
                    case 1:
                        threeObject = _a.sent();
                        threeObject = this.utils.setThreeShapeProperties(params, threeObject);
                        if (params.geometry && threeObject instanceof realms_three_1.default.Mesh) {
                            threeObject.geometry.dispose();
                            threeObject.geometry = new realms_three_1.default.BoxGeometry(params.geometry.width, params.geometry.height, params.geometry.depth);
                        }
                        return [2 /*return*/, threeObject];
                }
            });
        });
    };
    return BoxDataObjectBuilder;
}(AbstractDataObjectBuilder_1.AbstractDataObjectBuilder));
exports.BoxDataObjectBuilder = BoxDataObjectBuilder;
